import CodeButtons from '@components/code_buttons';
import EngineVersion from '@components/engine_version';
import * as React from 'react';
export default {
  CodeButtons,
  EngineVersion,
  React
};